// Actions
export const GET_USER_TRANSACTIONS = 'golagol/profile/actions/get_user_transactions';
export const GET_USER_TRANSACTIONS_SUCCESS = 'golagol/profile/actions/get_user_transactions_success';
export const GET_USER_TRANSACTIONS_ERROR = 'golagol/profile/actions/get_user_transactions_error';
export const GET_USER_INFO = 'golagol/profile/actions/get_user_info';
export const GET_USER_INFO_SUCCESS = 'golagol/profile/actions/get_user_info_success';
export const GET_USER_INFO_ERROR = 'golagol/profile/actions/get_user_info_error';

// Getters
export const USER_TRANSACTIONS = 'golagol/profile/getters/user_transactions';
export const USER_INFO = 'golagol/profile/getters/user_info';
